/**
 * Notification Context and Types
 *
 * Centralized context for notification system
 */

import { createContext } from 'react';

// Notification Types
export interface Notification {
  id: string;
  type: 'opportunity' | 'bid_update' | 'contract' | 'message' | 'group_buy' | 'quote' | 'system';
  title: string;
  message: string;
  timestamp: Date;
  read: boolean;
  actionUrl?: string;
  priority: 'low' | 'medium' | 'high';
  relatedEntityId?: string;
  relatedEntityType?: string;
  data?: Record<string, unknown>;
}

export interface NotificationAction {
  type:
    'ADD_NOTIFICATION' | 'MARK_AS_READ' | 'DISMISS_NOTIFICATION' | 'MARK_ALL_AS_READ' | 'CLEAR_ALL';
  payload?: unknown;
}

export interface NotificationContextType {
  notifications: Notification[];
  unreadCount: number;
  addNotification: (notification: Notification) => void;
  markAsRead: (id: string) => void;
  dismissNotification: (id: string) => void;
  markAllAsRead: () => void;
  clearAll: () => void;
  subscribeToEvents: () => void;
  unsubscribeFromEvents: () => void;
}

export const NotificationContext = createContext<NotificationContextType | null>(null);
